module.exports = __webpack_public_path__ + "img/box1_title.1090e0aa.png";